import {
  BarChartOutlined,
  BookOutlined,
  BulbOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CarOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DollarOutlined,
  DoubleRightOutlined,
  FileProtectOutlined,
  FundOutlined,
  HeartOutlined,
  HeatMapOutlined,
  HistoryOutlined,
  HomeOutlined,
  LineChartOutlined,
  MessageOutlined,
  PushpinOutlined,
  RadiusSettingOutlined,
  SettingOutlined,
  SnippetsOutlined,
  ToolOutlined,
  UserOutlined,
  WarningOutlined,
  CarryOutOutlined,
} from '@ant-design/icons';
import { Drawer, Layout, Menu } from 'antd';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { customFleets } from 'shared';
import { AppStore, CurrentUserStore, ShopStore } from 'stores';
import deviceStore from 'stores/Classes/DeviceStore';

const { Sider } = Layout;

const Sidebar = ({ history, collapsed, toggleSideBar }) => {
  const [shopSettings, setShopSettings] = useState(null);

  useEffect(() => {
    // Load shop settings to check for feature flags
    const loadShopSettings = async () => {
      try {
        const settings = await ShopStore.getShopSettings();
        setShopSettings(settings);
      } catch (error) {
        console.error('Failed to load shop settings:', error);
      }
    };

    if (ShopStore.currentShop?.id && ShopStore.currentShop.id !== -1) {
      loadShopSettings();
    }
  }, [ShopStore.currentShop?.id]);

  const onClose = () => {
    toggleSideBar();
  };

  const getFleetAnalytics = () => {
    const defaultItems = [
      {
        key: '/highpriorityvehicles',
        icon: <CarOutlined />,
        label: 'High Priority Vehicles',
        onClick: () => history.push('/highpriorityvehicles'),
      },
      {
        key: '/location',
        icon: <PushpinOutlined />,
        label: 'Fleet Live Location',
        onClick: () => history.push('/location'),
      },
      {
        key: '/fleet-reports',
        icon: <BarChartOutlined />,
        label: 'Fleet Reports',
        onClick: () => history.push('/fleet-reports'),
      },
    ];

    // Check if shop has the data miner menu feature flag enabled
    const showDataMinerMenu =
      shopSettings?.result?.[0]?.settings?.featureFlags?.showDataMinerMenu ||
      shopSettings?.result?.[0]?.settings?.featureFlags?.showRawDataMenu ||
      false; // Support both old and new flag names

    // Add Data Miner menu if feature flag is enabled for ANY shop
    if (showDataMinerMenu) {
      defaultItems.push({
        key: '/data-miner',
        icon: <DatabaseOutlined />,
        label: 'Data Miner',
        onClick: () => history.push('/data-miner'),
      });
    }

    const isCardinalCouriersShop = customFleets.cardinalCourier.includes(
      ShopStore.currentShop.id
    );
    const isAmerTestShop = ShopStore.currentShop.id === 1326;

    const isGeorgiaPower = customFleets.georgiapower.includes(
      ShopStore.currentShop.id
    );
    const isTimHortons = customFleets.timhortons.includes(
      ShopStore.currentShop.id
    );
    const isExcludedShop = isGeorgiaPower || isTimHortons;

    if (isCardinalCouriersShop) {
      return [
        ...defaultItems,
        {
          key: '/downtimecost',
          icon: <DollarOutlined />,
          label: 'Downtime Cost Analytics',
          onClick: () => history.push('/downtimecost'),
        },
        {
          key: '/fleethealth',
          icon: <HeartOutlined />,
          label: 'Fleet Ranking',
          onClick: () => history.push('/fleethealth'),
        },
        {
          key: '/shopperformance',
          icon: <LineChartOutlined />,
          label: 'Shop Performance',
          onClick: () => history.push('/shopperformance'),
        },
        {
          key: '/reports',
          icon: <BarChartOutlined />,
          label: 'Technician Efficiency',
          onClick: () => history.push('/reports'),
        },
      ];
    }

    if (isAmerTestShop) {
      return defaultItems;
    } else if (isExcludedShop) {
      return defaultItems.filter((obj) => obj.key !== '/location');
    }
    return defaultItems;
  };

  const getAdminDealerSidebar = () => {
    // const isLongBeachShopAndAdminOrCustomLongBeachUsers =
    //   ShopStore.currentShop.id === 1085 &&
    //   (CurrentUserStore.user.role === 'admin' ||
    //     [13512, 11719, 13620].includes(CurrentUserStore.user.id));

    // if (isLongBeachShopAndAdminOrCustomLongBeachUsers) {
    //   return [
    //     {
    //       key: 'Analytics_Fleet_Performance',
    //       icon: <DashboardOutlined />,
    //       label: 'Fleet Analytics',
    //       children: [
    //         {
    //           key: '/highpriorityvehicles',
    //           icon: <CarOutlined />,
    //           label: 'High Priority Vehicles',
    //           onClick: () => history.push('/highpriorityvehicles'),
    //         },
    //         {
    //           key: '/downtimecost',
    //           icon: <DollarOutlined />,
    //           label: 'Downtime Cost Analytics',
    //           onClick: () => history.push('/downtimecost'),
    //         },
    //         {
    //           key: '/algorithminsights',
    //           icon: <BulbOutlined />,
    //           label: 'Algorithm Insights',
    //           onClick: () => history.push('/algorithminsights'),
    //         },
    //         {
    //           key: '/fleethealth',
    //           icon: <HeartOutlined />,
    //           label: 'Fleet Ranking',
    //           onClick: () => history.push('/fleethealth'),
    //         },
    //         {
    //           key: '/idlingfuelreports',
    //           icon: <HeatMapOutlined />,
    //           label: 'Idling Reports',
    //           onClick: () => history.push('/idlingfuelreports'),
    //         },
    //         {
    //           key: '/alertsaccuracy',
    //           icon: <BarChartOutlined />,
    //           label: 'Alerts Accuracy',
    //           onClick: () => history.push('/alertsaccuracy'),
    //         },
    //         {
    //           key: '/shopperformance',
    //           icon: <LineChartOutlined />,
    //           label: 'Shop Performance',
    //           onClick: () => history.push('/shopperformance'),
    //         },
    //       ],
    //     },
    //     {
    //       key: 'Smart_Maintenance',
    //       icon: <RadiusSettingOutlined />,
    //       label: 'Smart Maintenance',
    //       children: [
    //         {
    //           key: '/vehicles',
    //           icon: <CarOutlined />,
    //           label: 'Vehicles',
    //           onClick: () => history.push('/vehicles'),
    //         },
    //         {
    //           key: '/issues',
    //           icon: <WarningOutlined />,
    //           label: 'Issue Management',
    //           onClick: () => history.push('/issues'),
    //         },
    //         {
    //           key: '/appointments',
    //           icon: <LineChartOutlined />,
    //           label: 'Smart PM Schedule',
    //           onClick: () => history.push('/appointments'),
    //         },
    //         {
    //           key: '/location',
    //           icon: <PushpinOutlined />,
    //           label: 'Fleet Live Location',
    //           onClick: () => history.push('/location'),
    //         },
    //         {
    //           key: '/service-interval',
    //           icon: <ToolOutlined />,
    //           label: 'Service Intervals',
    //           onClick: () => history.push('/service-interval'),
    //         },
    //       ],
    //     },
    //     {
    //       key: 'Settings',
    //       icon: <SettingOutlined />,
    //       label: 'Settings',
    //       children: [
    //         {
    //           key: '/contacts',
    //           icon: <ContactsOutlined />,
    //           label: 'Vendor Management',
    //           onClick: () => history.push('/contacts'),
    //         },
    //         {
    //           key: '/users',
    //           icon: <UserOutlined />,
    //           label: 'Users & Notifications',
    //           onClick: () => history.push('/user-management'),
    //         },
    //       ],
    //     },
    //   ];
    // }

    const isCardinalCouriersShop = customFleets.cardinalCourier.includes(
      ShopStore.currentShop.id
    );

    const fleetAnalytics = {
      key: 'Analytics_Fleet_Performance',
      icon: <DashboardOutlined />,
      label: 'Fleet Analytics',
      children: getFleetAnalytics(),
    };

    const smartMaintenance = isCardinalCouriersShop
      ? {
          key: 'Smart_Maintenance_Cardinal_Courier',
          icon: <RadiusSettingOutlined />,
          label: 'Smart Maintenance',
          children: [
            {
              key: '/appointments',
              icon: <LineChartOutlined />,
              label: 'Smart PM Schedule',
              onClick: () => history.push('/appointments'),
            },
          ],
        }
      : null;

    const settingsItems = [
      {
        key: '/contacts',
        icon: <ContactsOutlined />,
        label: 'Vendor Management',
        onClick: () => history.push('/contacts'),
      },
      {
        key: '/users',
        icon: <UserOutlined />,
        label: 'Users & Notifications',
        onClick: () => history.push('/user-management'),
      },
      {
        key: '/archived-assets',
        icon: <HistoryOutlined />,
        label: 'Archived Assets',
        onClick: () => history.push('/archived-assets'),
      },
      {
        key: '/shop-locations',
        icon: <HomeOutlined />,
        label: 'Sub-locations',
        onClick: () => history.push('/shop-locations'),
      },
    ];

    const settings = {
      key: 'Settings',
      icon: <SettingOutlined />,
      label: 'Settings',
      children: settingsItems,
    };

    const maintenanceItems = [
      {
        key: '/vehicles',
        icon: <CarOutlined />,
        label: 'Asset Management',
        onClick: () => history.push('/vehicles'),
        'data-testid': 'assets-submenu-item',
      },
      {
        key: '/issues',
        icon: <WarningOutlined />,
        label: 'Issues',
        onClick: () => history.push('/issues'),
        'data-testid': 'issues-submenu-item',
      },
      {
        key: '/parts',
        icon: <i className="fas fa-boxes" style={{ width: 14 }} />,
        label: 'Parts List',
        onClick: () => history.push('/parts'),
        'data-testid': 'parts-submenu-item',
      },
      {
        key: '/work-order',
        icon: <BookOutlined />,
        label: 'Work Order Management',
        onClick: () => history.push('/work-order'),
        'data-testid': 'work-order-management-submenu',
      },
      {
        key: '/sftp-work-orders',
        icon: <DatabaseOutlined />,
        label: 'Bulk Work Order Scan',
        onClick: () => {
          history.push('/sftp-work-order');
        },
        'data-testid': 'sftp-work-orders-submenu',
      },
      {
        key: '/purchase-orders',
        icon: <SnippetsOutlined />,
        label:
          ShopStore.currentShop.id === 374 ? 'Invoices' : 'Purchase Orders',
        onClick: () => history.push('/purchase-orders'),
      },
      {
        key: '/service-interval',
        icon: <CalculatorOutlined />,
        label: 'Service Intervals',
        onClick: () => history.push('/service-interval'),
      },
      {
        key: '/warranties',
        icon: <FileProtectOutlined />,
        label: 'Warranties',
        onClick: () => history.push('/warranties'),
      },
      {
        key: '/inspection-forms',
        icon: <CarryOutOutlined />,
        label: 'Inspection Forms',
        onClick: () => {
          history.push('/inspection-forms');
        },
      },
    ];

    return [
      {
        key: 'Smart_Maintenance',
        icon: <ToolOutlined />,
        label: 'Maintenance',
        children: maintenanceItems,
        'data-testid': 'maintenance-menu',
      },
      fleetAnalytics,
      smartMaintenance,
      settings,
    ].filter(Boolean);
  };

  const getUserSidebar = () => [
    {
      key: `/user/${CurrentUserStore.user.id}`,
      icon: <UserOutlined />,
      label: 'My Profile',
      onClick: () => history.push(`/user/${CurrentUserStore.user.id}`),
    },
    {
      key: '/cars',
      icon: <CarOutlined />,
      label: 'Vehicles',
      onClick: () => history.push('/cars'),
    },
    {
      key: '/appointments',
      icon: <CalendarOutlined />,
      label: 'Appointments',
      onClick: () => history.push('/appointments'),
    },
    {
      key: '/pages/chat',
      icon: <MessageOutlined />,
      label: 'Chat',
      onClick: () => history.push('/pages/chat'),
    },
  ];

  const getTechnicianSidebar = () => [
    {
      key: 'Assets_Overview',
      icon: <DashboardOutlined />,
      label: 'Assets overview',
      children: [
        {
          key: '/vehicles',
          icon: <CarOutlined />,
          label: 'Assets',
          onClick: () => history.push('/vehicles'),
        },
      ],
    },
    {
      key: 'Maintenance',
      icon: <ToolOutlined />,
      label: 'Maintenance',
      children: [
        {
          key: '/work-order',
          icon: <BookOutlined />,
          label: 'Work Order Management',
          onClick: () => history.push('/work-order'),
          'data-testid': 'work-order-management-menu',
        },
        {
          key: '/parts',
          icon: <i className="fas fa-boxes" style={{ marginRight: 7 }} />,
          label: 'Parts List',
          onClick: () => history.push('/parts'),
        },
        {
          key: '/inspection-forms',
          icon: <CarryOutOutlined />,
          label: 'Inspection Forms',
          onClick: () => {
            history.push('/inspection-forms');
          },
        },
      ],
    },
  ];

  const getNoAuthSidebar = () => [
    {
      key: '/login',
      label: 'Login',
      onClick: () => history.push('/login'),
    },
    {
      key: '/register',
      label: 'Register',
      onClick: () => history.push('/register'),
    },
  ];

  const getCustomSideBar = () => [
    {
      key: '/report',
      icon: <BarChartOutlined />,
      label: 'Dashboard',
      onClick: () => history.push('/report'),
    },
    {
      key: '/cars',
      icon: <CarOutlined />,
      label: 'Vehicles',
      onClick: () => history.push('/cars'),
    },
    {
      key: '/user-management',
      icon: <UserOutlined />,
      label: 'User Management',
      onClick: () => history.push('/user-management'),
    },
    {
      key: '/usage-report',
      icon: <FundOutlined />,
      label: 'Usage Report',
      onClick: () => history.push('/usage-report'),
    },
  ];

  let sections = [];
  if (CurrentUserStore.loaded) {
    if (!CurrentUserStore.user) {
      sections = getNoAuthSidebar();
    } else {
      switch (CurrentUserStore.user.role) {
        case 'admin':
        case 'dealership':
          sections = getAdminDealerSidebar();
          break;
        case 'technician':
          sections = getTechnicianSidebar();
          break;
        case 'user':
        default:
          sections = getUserSidebar();
      }
    }
  }

  const isAdminAndNussbaumShop = false; // ShopStore.currentShop.id === 1065 && CurrentUserStore.user.role === 'admin'

  const menuProps = {
    mode: 'inline',
    selectedKeys: [AppStore.selectedSidebarKey],
    defaultOpenKeys: [
      'Smart_Maintenance',
      'Analytics_Fleet_Performance',
      'Settings',
      'assets_overview',
    ],
    style: {
      height: '100%',
      borderRight: 0,
      overflowY: 'auto',
      overflowX: 'clip',
    },
    items: customFleets.gmrv.includes(ShopStore.currentShop.id)
      ? getCustomSideBar()
      : sections,
  };

  if (deviceStore.device === 'desktop') {
    return (
      <Sider
        width={isAdminAndNussbaumShop ? 320 : 260}
        collapsedWidth={0}
        style={{
          background: '#fff',
          position: 'fixed',
          top: '64px',
          height: '90vh',
          zIndex: 3,
          overflowY: 'auto',
          overflowX: 'clip',
        }}
        collapsed={collapsed}
      >
        <Menu {...menuProps} />
      </Sider>
    );
  }

  return (
    <Drawer
      closable={false}
      onClose={onClose}
      open={collapsed}
      width={deviceStore.device === 'tablet' ? undefined : 260}
    >
      <DoubleRightOutlined onClick={() => onClose()} style={{ fontSize: 20 }} />
      <Menu
        {...menuProps}
        onClick={() => {
          onClose();
        }}
      />
    </Drawer>
  );
};

Sidebar.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  collapsed: PropTypes.bool.isRequired,
  toggleSideBar: PropTypes.func,
};

export default withRouter(observer(Sidebar));
